// extracted by mini-css-extract-plugin
export default {"root":"UIKitModule_root__BWm6s","drawer":"UIKitModule_drawer__hs7ae","app-content":"UIKitModule_app-content__SImJe"};